<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xqBhgL/tc-custom/9781685502508.jpg?1718078778227" alt="This image is the cover for the book In the Dark Heart of Winter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Dark Heart of Winter
      </h1>
      <p class="bookDescription body article font2">
        <p>Isabeau is having history’s worst honeymoon. Heart-broken when her lover and best friend Margaret married and moved away, she accepted the proposal of a distant cousin, but she regrets this decision even before he insists on taking her to his cold and ruinous ancestral home. Horace does not seem to care about her, either, and soon she begins to wonder about his motives.<br/><br/>Her fears are compounded when strangers arrive seeking refuge from the snow, and her husband's behavior becomes strangely hostile. Vairya and Ranat seem friendly, but why are they in this isolated region at all? It can't be coincidence that they come from Persia, where her husband was until recently stationed as a diplomat.<br/><br/>Eventually one visitor confides in Isabeau, but her claims are so wild they cannot be true. Can they? Should she trust her heart, and perhaps her survival, to this stranger who seems to share her forbidden desires?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mere Rain
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?210328e8